export const SingleFamily = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 22 20'>
        <path
          d='M5.24839 6.59102V12.2951H12.8349V6.64938M4.24797 7.29298L8.99995 3.95826L13.7519 7.29298M10.3755 12.2951V9.96076C10.3755 9.46055 9.95868 9.04371 9.45848 9.04371H8.54143C8.04122 9.04371 7.62438 9.46055 7.62438 9.96076V12.2951M5.24839 0.623535H12.7548C14.8249 0.623535 16.5031 2.30173 16.5031 4.37176V11.8824C16.5031 13.9516 14.8249 15.6298 12.7548 15.6298H5.24505C3.17503 15.6298 1.49683 13.9516 1.49683 11.8816V4.3751C1.49683 2.3034 3.17669 0.623535 5.24839 0.623535Z'
          stroke='currentcolor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
};
